export const iconFontAwesomeWeatherTornado = (
	<i className="fa-solid fa-tornado"></i>
);
